import i18n from '@/lang/i18n'
import { i18nService } from '@/shared/services/i18n.service'
import { forEach, isObject } from 'lodash'
import moment from 'moment'
import { LocaleMessageObject } from 'vue-i18n'

interface i18nHelperFlattenTranslations {
    [key: string]: string
}

function plainToFlattenObject(object: LocaleMessageObject): i18nHelperFlattenTranslations {
    const result: i18nHelperFlattenTranslations = {}
    function flatten(obj: LocaleMessageObject, prefix = '') {
        forEach(obj, (value, key) => {
            if (isObject(value)) {
                flatten(value as {}, `${prefix}${key}.`)
            } else {
                result[`${prefix}${key}`] = value
            }
        })
    }
    flatten(object)
    return result
}

function setI18nLanguage(locale: string, idLocale: number): void {
    i18n.locale = locale
    moment.locale(locale)
    document.querySelector('html')?.setAttribute('lang', locale)

    sessionStorage.locale = locale
    sessionStorage.idLocale = idLocale
}

export async function loadLanguageAsync(locale: string, idLocale: number): Promise<void> {
    const messages = await i18nService.getTranslations(idLocale, locale)
    const localeMessages = i18n.getLocaleMessage(locale)
    const flattenLocaleMessages = plainToFlattenObject(localeMessages)
    const updatedLocaleMessages = {
        ...flattenLocaleMessages,
        ...messages
    }
    i18n.setLocaleMessage(locale, updatedLocaleMessages)
    return setI18nLanguage(locale, idLocale)
}
